<div class="sidebar included">
	<app-sidebar-header [title]="insurance" [label]="(insurancePricePerPax + currencyUnit | indracurrency) + ' ' + INDRA_translate('label', 'perPassenger') + ' ' + insuranceFreePaxText"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
		<div class="partner-content" [ngClass]="{'insurance-added': INDRA_checkInsurance()}">
			<div class="partner-content--text">
				<ng-container *ngIf="INDRA_checkInsurance(); else insuranceAdded">
					<h2 class="title-h2">{{insurance}} {{ INDRA_translate('text', 'insuranceAdded') }} </h2>
				</ng-container>
				<ng-template #insuranceAdded>
					<h2 class="title-h2">{{ INDRA_translate('text', 'whatYouGetWithInsurance') }}</h2>
				</ng-template>
			</div>
			<div class="partner-content--partner">
				<p>{{ INDRA_translate('text', 'withPartner') }}</p>
				<app-svg class="partner-content--partner-icon" svg="sprite.svg#partners--chubb" aria-hidden="true"
					[alt]="'Partner CHUBB'"></app-svg>
			</div>
		</div>
		<form [formGroup]="form" (ngSubmit)="INDRA_onSubmit()">
			<ng-container *ngIf="INDRA_checkInsurance()">
				<h2 class="title-h2">{{ INDRA_translate('text', 'whatYouGetWithInsurance') }}</h2>
			</ng-container>
			<div class="sidebar-flight-text">
				<div class="grid no-padding insurance-items">
					<div class="col-12 col-tp-12 col-p-12">
						<p *ngFor="let item of insuranceItems['coverages']">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" *ngIf="item.hasElement" [alt]="'Checked icon'"></app-svg>
							<app-svg class="list--checked__icon" svg="icons.svg#general--not_available" aria-hidden="true" *ngIf="!item.hasElement" [alt]="'Not available icon'"></app-svg>
							<span class="bold">{{ INDRA_translate(translation.COVERAGE, item.ibeAdminKey) }} </span>
						</p>
					</div>
				</div>
				
				<a *ngIf="specificInsuranceDocLink" 
					href="javascript:;" 
					(click)="INDRA_handleDocLinkClick(specificInsuranceDocLink)" 
					class="link link--external"  
					[attr.aria-label]="INDRA_translate('text', 'allAboutInsurance')">
					{{ INDRA_translate('text', 'allAbout') }} {{insurance}}
				</a>
				
				<a *ngIf="termsAndConditionDocLink" 
					href="javascript:;" 
					(click)="INDRA_handleDocLinkClick(termsAndConditionDocLink)" 
					class="link link--external" 
					[attr.aria-label]="INDRA_translate('text', 'termsAndCondition')">
					{{ INDRA_translate('text', 'termsAndCondition') }}
				</a>
				
				<a *ngIf="preContractualDocLink" 
					href="javascript:;" 
					(click)="INDRA_handleDocLinkClick(preContractualDocLink)" 
					class="link link--external" 
					[attr.aria-label]="INDRA_translate('text', 'preContractual')">
					{{ INDRA_translate('text', 'preContractual') }}
				</a>
				
				<div class="insurance-price" *ngIf="!insuranceItems?.isFromBookingView">
					<p> {{ INDRA_translate('text', 'totalForAllPassengers') }}: <span class="bold"> {{totalPrice + currencyUnit | indracurrency}} </span></p>
				</div>
				<ng-container *ngIf="!INDRA_checkInsurance() && !insuranceItems?.isFromBookingView; else removeInsurance">
					<ng-container *ngIf="market != 'HU'; else HUMarketConfirm">
						<div class="col-12 col-tp-12 col-p-12 top-gap" >
							<app-checkbox-input 
								[parentForm]="form" 
								[id]="'insurance'" 
								formControlName="insurance" 
								label="{{ INDRA_translate(null, 'insuranceConfirmNote.' + market) }}" 
								[attr.aria-label]="INDRA_translate('text', 'confirmLegalAge')">
							</app-checkbox-input>
							<span aria-live="polite" class="input-error display--block" role="alert" *ngIf="INDRA_hasErrors(form.get('insurance'))">
								{{INDRA_translate('text', 'acceptConditions')}}
							</span>
						</div>
					</ng-container>
					<ng-template #HUMarketConfirm>
						<div class="col-12 col-tp-12 col-p-12 top-gap" >
							<app-checkbox-input 
								[parentForm]="form" 
								[id]="'subConfirm1'" 
								formControlName="subConfirm1" 
								label="{{ INDRA_translate(null, 'insuranceConfirmNote.' + market + '.subConfirm1') }}" 
								[attr.aria-label]="INDRA_translate('text', 'confirmLegalAge')">
							</app-checkbox-input>
							<span aria-live="polite" class="input-error display--block" role="alert" *ngIf="INDRA_hasErrors(form.get('subConfirm1'))">
								{{INDRA_translate('text', 'acceptConditions')}}
							</span>
						</div>
						<div class="col-12 col-tp-12 col-p-12 top-gap" >
							<app-checkbox-input 
								[parentForm]="form" 
								[id]="'subConfirm2'" 
								formControlName="subConfirm2" 
								label="{{ INDRA_translate(null, 'insuranceConfirmNote.' + market + '.subConfirm2') }}" 
								[attr.aria-label]="INDRA_translate('text', 'confirmLegalAge')">
							</app-checkbox-input>
							<span aria-live="polite" class="input-error display--block" role="alert" *ngIf="INDRA_hasErrors(form.get('subConfirm2'))">
								{{INDRA_translate('text', 'acceptConditions')}}
							</span>
						</div>
						<div class="col-12 col-tp-12 col-p-12 top-gap" >
							<app-checkbox-input 
								[parentForm]="form" 
								[id]="'subConfirm3'" 
								formControlName="subConfirm3" 
								label="{{ INDRA_translate(null, 'insuranceConfirmNote.' + market + '.subConfirm3') }}" 
								[attr.aria-label]="INDRA_translate('text', 'confirmLegalAge')">
							</app-checkbox-input>
							<span aria-live="polite" class="input-error display--block" role="alert" *ngIf="INDRA_hasErrors(form.get('subConfirm3'))">
								{{INDRA_translate('text', 'acceptConditions')}}
							</span>
						</div>
						<div class="col-12 col-tp-12 col-p-12 top-gap" >
							<app-checkbox-input 
								[parentForm]="form" 
								[id]="'subConfirm4'" 
								formControlName="subConfirm4" 
								label="{{ INDRA_translate(null, 'insuranceConfirmNote.' + market + '.subConfirm4') }}" 
								[attr.aria-label]="INDRA_translate('text', 'confirmLegalAge')">
							</app-checkbox-input>
							<span aria-live="polite" class="input-error display--block" role="alert" *ngIf="INDRA_hasErrors(form.get('subConfirm4'))">
								{{INDRA_translate('text', 'acceptConditions')}}
							</span>
						</div>
						<div class="col-12 col-tp-12 col-p-12 top-gap" >
							<app-checkbox-input 
								[parentForm]="form" 
								[id]="'insurance'" 
								formControlName="insurance" 
								label="{{ INDRA_translate(null, 'insuranceConfirmNote.' + market + '.mainConfirm') }}" 
								[attr.aria-label]="INDRA_translate('text', 'confirmLegalAge')">
							</app-checkbox-input>
							<span aria-live="polite" class="input-error display--block" role="alert" *ngIf="INDRA_hasErrors(form.get('insurance'))">
								{{INDRA_translate('text', 'acceptConditions')}}
							</span>
						</div>
					</ng-template>
					
					<button class="button full-width" type="submit">
						{{ INDRA_translate('text', 'add') }} {{insurance}} {{ INDRA_translate('text', 'insuranceForAll') }}
					</button>
					<div class="insurance-disclaimer">
						<p class="bold" *ngIf="isMarketWithInfoNeeded">
							{{ INDRA_translate('text', 'specificForAllPassengers') }}
						</p>
						<p>
							{{ INDRA_translate(null, 'legalNotice.' + market) }}
						</p>
						<p *ngIf="privacyPolicyLink">
							{{ INDRA_translate(null, 'masterPrivatePolicyDesc')}} 
							<a [href]="privacyPolicyLink" class="link link--external" target="_blank">
								{{ INDRA_translate(null, 'masterPrivatePolicy') }}
							</a>
						</p>
						<p *ngIf="specificCovidDocLink">
							{{ INDRA_translate(null, 'covidNote')}} 
							<a href="javascript:;" (click)="INDRA_handleDocLinkClick(specificCovidDocLink)" class="link">
								{{ INDRA_translate(null, 'covidNoteHere') }}
							</a>
						</p>
					</div>
				</ng-container>
				<ng-template #removeInsurance>
					<!-- <div class="col-12 col-tp-12 col-p-12 top-gap">
						<app-checkbox-input [checked]="true" [disabledForm]="true" [parentForm]="form" [id]="'insurance'" formControlName="insurance" label="{{INDRA_translate('text', 'confirmLegalAge')}}" [attr.aria-label]="INDRA_translate('text', 'selectIConfirm')">
						</app-checkbox-input>
						<span aria-live="polite" class="input-error display--block" role="alert" *ngIf="INDRA_hasErrors(form.get('insurance'))">{{INDRA_translate('text', 'acceptConditions')}}</span>
					</div> -->
					<div class="insurance-disclaimer" *ngIf="!insuranceItems?.isFromBookingView">
						<p class="bold">
							{{ INDRA_translate('text', 'specificForAllPassengers') }}
						</p>
						<p>
							{{ INDRA_translate(null, 'legalNotice.' + market) }}
						</p>
						<p *ngIf="privacyPolicyLink">
							{{ INDRA_translate(null, 'masterPrivatePolicyDesc')}} 
							<a [href]="privacyPolicyLink" class="link link--external" target="_blank">
								{{ INDRA_translate(null, 'masterPrivatePolicy') }}
							</a>
						</p>
						<p *ngIf="specificCovidDocLink">
							{{ INDRA_translate(null, 'covidNote')}} 
							<a href="javascript:;" (click)="INDRA_handleDocLinkClick(specificCovidDocLink)" class="link">
								{{ INDRA_translate(null, 'covidNoteHere') }}
							</a>
						</p>
					</div>
					<button *ngIf="!insuranceItems?.isFromBookingView && !isModificationDisallowed" (click)="INDRA_insuranceRemove()" class="button full-width button-main-line">
						{{ INDRA_translate('text', 'remove') }} {{insurance}}
					</button>
				</ng-template>
			</div>
		</form>
		<div class="sidebar-flight-text">
			<p>
				<a class="link link--close" [attr.aria-label]="INDRA_translate('text', 'closeSidebar')" (click)="INDRA_handleClose()" href="javascript:;" role="button">{{ INDRA_translate('text', 'closeThisWindow') }}</a>
			</p>
		</div>
	</div>
</div>
